import * as React from "react";
export const OpsanioAnimated = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd"
    id="svg8"
    width={"250px"}
    height={"250px"}
    viewBox="0 0 106 119"
    {...props}
  >
    <g id="left">
      <path
        id="leftBottom"
        fill="#26388b"
        stroke="none"
        strokeWidth="0.2"
        d="M11 84 2 89 52 117 60 112Z"
      >
        <animate
          attributeName="opacity"
          dur="3s"
          repeatCount="indefinite"
          keyTimes="0;0.25;0.5;0.75;0.9;1"
          values="0;0.5;0.75;0.9;0.9;0"
        />
      </path>
      <path
        id="leftLeft"
        fill="#26388b"
        stroke="none"
        strokeWidth="0.2"
        d="M11 32 11 32 11 84 2 89 2 31 8.25 27.57Z"
      >
        <animate
          attributeName="opacity"
          dur="3s"
          repeatCount="indefinite"
          begin="0.2s"
          keyTimes="0;0.25;0.5;0.75;0.9;1"
          values="0;0.5;0.75;0.9;0.9;0"
        />
      </path>
      <path
        id="leftTop"
        fill="#26388b"
        stroke="none"
        strokeWidth="0.2"
        d="M8.25 27.57 16 23.3 84 63 84 73 11 32Z"
      >
        <animate
          attributeName="opacity"
          dur="3s"
          repeatCount="indefinite"
          begin="0.4s"
          keyTimes="0;0.25;0.5;0.75;0.9;1"
          values="0;0.5;0.75;0.9;0.9;0"
        />
      </path>
    </g>
    <g id="right">
      <path
        id="rightBottom"
        fill="#3e73b9"
        stroke="none"
        strokeWidth="0.2"
        d="M92 87 19 46 19 57 88 96 95 92Z"
      >
        <animate
          attributeName="opacity"
          dur="3s"
          repeatCount="indefinite"
          begin="0.6s"
          keyTimes="0;0.25;0.5;0.75;0.9;1"
          values="0;0.5;0.75;0.9;0.9;0"
        />
      </path>
      <path
        id="rightRight"
        fill="#3e73b9"
        stroke="none"
        strokeWidth="0.2"
        d="M92 87 95 92 102 88 102 31 92 36Z"
      >
        <animate
          attributeName="opacity"
          dur="3s"
          repeatCount="indefinite"
          begin="0.8s"
          keyTimes="0;0.25;0.5;0.75;0.9;1"
          values="0;0.5;0.75;0.9;0.9;0"
        />
      </path>
      <path
        id="rightTop"
        fill="#3e73b9"
        stroke="none"
        strokeWidth="0.2"
        d="M92 36 102 31 53 2.5 43 8Z"
      >
        <animate
          attributeName="opacity"
          dur="3s"
          repeatCount="indefinite"
          begin="1s"
          keyTimes="0;0.25;0.5;0.75;0.9;1"
          values="0;0.5;0.75;0.9;0.9;0"
        />
      </path>
    </g>
    <path
      id="top"
      fill="#009eae"
      stroke="none"
      strokeWidth="0.2"
      d="M25.5 18 35 12.75 84 41 84 52Z"
    >
      <animate
        attributeName="opacity"
        dur="3s"
        repeatCount="indefinite"
        keyTimes="0;0.25;0.5;0.75;0.9;1"
        values="0;0.5;0.75;0.9;0.9;0"
      />
    </path>
    <path
      id="bottom"
      fill="#78c9d9"
      stroke="none"
      strokeWidth="0.2"
      d="m19 67L79 101.35 69.25 107 19 78 19 67Z"
    >
      <animate
        attributeName="opacity"
        dur="3s"
        repeatCount="indefinite"
        keyTimes="0;0.25;0.5;0.75;0.9;1"
        values="0;0.5;0.75;0.9;0.9;0"
      />
    </path>
  </svg>
);
